// extracted by mini-css-extract-plugin
export var avatar = "style-module--avatar--ab51b";
export var more = "style-module--more--ad65f";